/** Telugu summaries for standalone legal pages (toggle on /terms, /privacy, etc.) */
export const LEGAL_TE_SUMMARIES = {
  terms: {
    title: 'నిబంధనలు & షరతులు',
    body:
      'రేపటికోసం M S Publications ద్వారా నిర్వహించబడుతుంది. వార్షిక సభ్యత్వం ₹999 + GST (INR). భారత్ మరియు అంతర్జాతీయ కస్టమర్లు Razorpay ద్వారా చెల్లించవచ్చు. కంటెంట్ M S Publications ఆస్తి.',
  },
  privacy: {
    title: 'గోప్యతా విధానం',
    body:
      'Google సైన్-ఇన్, చెల్లింపు స్థితి సేకరిస్తాము. కార్డ్ వివరాలు Razorpay వద్దే — మాకు నిల్వ కాదు. అంతర్జాతీయ కస్టమర్ల డేటా కూడా భద్రతా ప్రమాణాల ప్రకారం నిర్వహించబడుతుంది.',
  },
  refund: {
    title: 'రీఫండ్ విధానం',
    body:
      '7 రోజులలో, 3 సార్లకు మించి ఉపయోగం లేకుంటే పూర్తి రీఫండ్. అంతర్జాతీయ కార్డ్ రీఫండ్ అసలు చెల్లింపు పద్ధతికి INR లో తిరిగి వస్తుంది (5–10 పని దినాలు).',
  },
  cancellation: {
    title: 'రద్దు విధానం',
    body:
      'ఒకేసారి వార్షిక చెల్లింపు — ఆటో-డెబిట్ లేదు. రద్దు: contact@repatikosam.com. చెల్లించిన కాలం వరకు యాక్సెస్ (రీఫండ్ విధానం ప్రకారం).',
  },
  contact: {
    title: 'సంప్రదింపు',
    body:
      'M S Publications · GSTIN 37ACCFM0063B1ZS · గుంటూరు. ఇమెయిల్/WhatsApp: contact@repatikosam.com · +91 90904 48890. అంతర్జాతీయ కస్టమర్లకు Razorpay ద్వారా సహాయం.',
  },
};

export const LEGAL_PAGE_META = {
  '/terms': { icon: '📜', accent: '#1a6b2f' },
  '/privacy': { icon: '🔒', accent: '#1565c0' },
  '/refund': { icon: '↩️', accent: '#e65100' },
  '/cancellation': { icon: '✕', accent: '#6a1b9a' },
  '/contact': { icon: '💬', accent: '#25d366' },
};
